const cookie_set = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const urlParams = searchParams.get('index');
  const cookie_register_code = Cookies.get('register_code');

  if (urlParams == 'wholesale-salon-form') {
    Cookies.set('register_code', 'WHOLESALE-SALON-REGISTER', { expires: 7 });
  } else if (urlParams == 'wholesale-nailist-form') {
    Cookies.set('register_code', 'WHOLESALE-NAILIST-REGISTER', { expires: 7 });
  } else if (urlParams == 'wholesale-student-form') {
    Cookies.set('register_code', 'WHOLESALE-STUDENT-REGISTER', { expires: 7 });
  } else if (urlParams == 'wholesale_r') {
    Cookies.set('register_code', 'WHOLESALE-REGISTER', { expires: 7 });
  } else if (urlParams == 'common_r') {
    Cookies.set('register_code', 'COMMON-REGISTER', { expires: 7 });
  } else if (cookie_register_code == 'WHOLESALE-SALON-REGISTER') {
    Cookies.set('register_code', 'WHOLESALE-SALON-REGISTER', { expires: 7 });
  } else if (cookie_register_code == 'WHOLESALE-NAILIST-REGISTER') {
    Cookies.set('register_code', 'WHOLESALE-NAILIST-REGISTER', { expires: 7 });
  } else if (cookie_register_code == 'WHOLESALE-STUDENT-REGISTER') {
    Cookies.set('register_code', 'WHOLESALE-STUDENT-REGISTER', { expires: 7 });
  } else if (cookie_register_code == 'COMMON-REGISTER') {
    Cookies.set('register_code', 'COMMON-REGISTER', { expires: 7 });
  } else {
    Cookies.set('register_code', 'COMMON-REGISTER', { expires: 7 });
  }
  const current_cookie_register_code = Cookies.get('register_code');
}

const show_wc_func = (text) => {
  document.querySelectorAll(`[data-change-wc]`).forEach(value => value.style.display = 'none')
  document.querySelectorAll(`[data-change-wc="${text}"]`).forEach(value => value.style.display = 'grid')
}

const display_wc_func = () => {
  const register_code = Cookies.get('register_code');
  if (register_code == 'WHOLESALE-SALON-REGISTER') {
    show_wc_func('wholesale-salon-form')
  } else if (register_code == 'WHOLESALE-NAILIST-REGISTER') {
    show_wc_func('wholesale-nailist-form')
  } else if (register_code == 'WHOLESALE-STUDENT-REGISTER') {
    show_wc_func('wholesale-student-form')
  } else if (register_code == 'WHOLESALE-REGISTER') {
    show_wc_func('wholesale_r')
  } else if (register_code == 'COMMON-REGISTER') {
    show_wc_func('common_r')
  }
}

window.addEventListener('DOMContentLoaded', function () {
  cookie_set()
  display_wc_func()
  setTimeout(() => {
    display_wc_func()
  }, 500);
  setTimeout(() => {
    display_wc_func()
  }, 1000);
  document.querySelector('body').classList.add('loaded')
})